import { useContext, useEffect, useState } from "react"
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance"
import AppContext from "../../../../../AppContext/AppContext"
import CreateButton from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDashboardBoilerplate/CRUDHeader/CreateButton/CreateButton"
import CRUDTable from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable"
import CRUDTableHeader from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader"
import CRUDth from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth"
import CRUDTableRow from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow"
import ShortTextCell from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell"
import ViewButton from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ViewButton/ViewButton"
import EditButton from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/EditButton/EditButton"
import DeleteButton from "../../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/DeleteButton/DeleteButton"
import Modal from "../../../../Partials/Elements/Modal/Modal"
import { SUBCATEGORIES_API } from "../../../../../Utilities/APIs/APIs"
import { useParams } from "react-router-dom"
import CreateSubcategory from "./CreateSubcategory"
import ViewSubcategory from "./ViewSubcategory"
import UpdateSubcategory from "./UpdateSubcategory"
import DeleteItem from "../../../../Partials/Layouts/DeleteItem/DeleteItem"

function SubCategories() {

    const [subcategories, setSubcategories] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [targetID, setTargetID] = useState(null)
    const [showViewSection, setShowViewSection] = useState(false)
    const [showCreateForm, setShowCreateForm] = useState(false)
    const [showUpdateForm, setShowUpdateForm] = useState(false)
    const [showDeleteSection, setShowDeleteSection] = useState(false)
    const [toggleFetch, setToggleFetch] = useState(false)
    const { employee } = useContext(AppContext)

    const axiosInstance = useAxiosInstance()
    const {categoryId} =useParams()

    useEffect(() => {

        async function fetchAndSetCategories() {
            const { data } = await axiosInstance.get(SUBCATEGORIES_API + 'getSubcategoriesByCategory/' + categoryId)
            setSubcategories(data)
        }
        fetchAndSetCategories()


    }, [toggleFetch, axiosInstance,  categoryId])

    function handleClose() {
        setShowModal(false);
        setShowCreateForm(false);
        setShowViewSection(false);
        setShowUpdateForm(false);
        setShowDeleteSection(false);
    }

    function triggerFetch() {
        setToggleFetch(prevState => !prevState)
    }


    return (
        <>
            <div className='crud_holder'>
                <div className="body_header">
                    <h1 className="heading">{`Subcategories (${subcategories?.length} in total)`}</h1>
                    <CreateButton
                        screenTopicSingular='Subcategory'
                        setShowModal={setShowModal}
                        setShowCreateForm={setShowCreateForm}
                    />
                </div>
                <CRUDTable>
                    <CRUDTableHeader>
                        <CRUDth th='Name' />
                        <CRUDth th='Description' />
                        <CRUDth th='Actions' />
                    </CRUDTableHeader>
                    <tbody>
                        {subcategories?.map(subcategory => (
                            <CRUDTableRow key={subcategory._id}>
                                <ShortTextCell text={subcategory.name} />
                                <ShortTextCell text={subcategory.description} />


                                <td className="action_button_cell">
                                    <ViewButton
                                        setShowModal={setShowModal}
                                        setShowViewSection={setShowViewSection}
                                        targetID={subcategory._id}
                                        setTargetID={setTargetID}
                                    />
                                    <EditButton
                                        setShowModal={setShowModal}
                                        setShowUpdateForm={setShowUpdateForm}
                                        targetID={subcategory._id}
                                        setTargetID={setTargetID}
                                    />
                                    <DeleteButton
                                        setShowModal={setShowModal}
                                        setShowDeleteSection={setShowDeleteSection}
                                        targetID={subcategory._id}
                                        setTargetID={setTargetID}
                                    />

                                </td>
                            </CRUDTableRow>
                        ))}
                    </tbody>
                </CRUDTable>
            </div>
            {showModal &&
                <Modal
                    view
                    handleClose={handleClose}
                    modalHeading={
                        (showCreateForm && `Create Subcategory`) ||
                        (showUpdateForm && `Update Subcategory`) ||
                        (showDeleteSection && `Delete Subcategory`)
                    }
                >
                    {
                        showCreateForm &&
                        <CreateSubcategory
                            employee={employee}
                            setShowCreateForm={setShowCreateForm}
                            setShowModal={setShowModal}
                            triggerFetch={triggerFetch}
                            categoryId={categoryId}
                        />
                    }
                    {
                        showUpdateForm &&
                        <UpdateSubcategory
                            targetID={targetID}
                            setShowUpdateForm={setShowUpdateForm}
                            setShowModal={setShowModal}
                            triggerFetch={triggerFetch}
                            categoryId={categoryId}
                        />
                    }

                    
                    {
                        showDeleteSection &&
                        <DeleteItem
                            api={SUBCATEGORIES_API}
                            targetID={targetID}
                            employee={employee}
                            setShowModal={setShowModal}
                            setShowDeleteSection={setShowDeleteSection}
                            hasName
                            triggerFetch={triggerFetch}
                        />
                    }
                </Modal>
            }

            {showModal && showViewSection &&
                <Modal
                    view
                    handleClose={handleClose}
                    modalHeading={
                        (showViewSection && `View Category`)
                    }
                >
                    <ViewSubcategory
                        targetID={targetID}
                    />
                </Modal>
            }
        </>
    )
}

export default SubCategories